<template>
  <div class="files">
    <card-grid
      v-if="status === 0"
      :data="data"
      type="file"
      @on-delete-click="handleOnDeleteChange"
      @on-preview-click="handleOnPreviewChange"
    >
    </card-grid>
    <mini-program-authorize-info
      v-else-if="status > 0"
      hide-button
      content="请在小程序审核完成后，选取小程序资料进行添加"
    />
  </div>
</template>

<script>
import { miniAuthStatusCheck } from '@utils/check-mini-program-authorize'
import MiniProgramAuthorizeInfo from '@/components/mini-program-authorize-info'
export default {
  name: 'Files',
  components: {
    MiniProgramAuthorizeInfo
  },
  props: {
    data: {
      type: Array,
      default () {
        return []
      }
    }
  },
  data () {
    return {
      status: false
    }
  },
  created () {
    this.getMiniAuthStatus()
  },
  methods: {
    handleOnDeleteChange (data) {
      this.$emit('on-delete-click', data)
    },
    handleOnPreviewChange (data) {
      this.$emit('on-preview-click', data)
    },
    // 获取小程序审核状态
    async getMiniAuthStatus () {
      this.status = await miniAuthStatusCheck()
      if (this.status) this.$emit('disabled-add')
    }
  }
}
</script>
